// extracted by mini-css-extract-plugin
export default {"moveIcon":"AdminMobileMainPage_moveIcon__RvmFw","borderBot":"AdminMobileMainPage_borderBot__oi756"};